import { useState } from "react";
import myResStyles from "../../../styles/myResources.module.css";
import SuccessErrorModal, { MessageType } from "../../modals/SuccessErrorModal";
import modalStyle from '../../../styles/SuccessError.module.css';
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";

const ResourceStatus = ({
  resouceData,
  reourceColor,
  roleStatus,
  icon,
}: any) => {

  const [open, setOpen] = useState<boolean>(false)
  const [messageToSend, setMessageToSend] = useState<JSX.Element>(<></>)

  const handleClose =()=>{
    setOpen(false)
  }
  
  const handleMessage = ( emails : string) => {
    let adminEmails : string[] = emails.split(';')
    let uiElement: JSX.Element = <></>;
    let children: JSX.Element[] = [];
    if (adminEmails.length > 0){
      children.push(
        <div className={myResStyles.textmessage}>
          For further assistance with this resource, contact client admins: 
          <br /><br />
          <a className={myResStyles.adminEmails}>{adminEmails[0]}</a> (Primary) <br></br>
          <a className={myResStyles.adminEmails}>{adminEmails[1]}</a> (Secondary)
        </div>
      )
    }
    else {
      children.push(
        <div >
          For further assistance with this resource, contact client admins: 
          <br /><br />
          <a style={{textDecoration:'none'}}>{adminEmails[0]}</a> (Primary) <br></br>
        </div>
      )
    }
    uiElement = <div>{children}</div>;
    setMessageToSend(uiElement);
  }
    
  

  return (
    <>
      <SuccessErrorModal
          type={MessageType.dialog}
          open={open}
          handleClose={handleClose}
          style={modalStyle}
          title={"Resource support"}
          messageHTML={messageToSend} />
      <div className={myResStyles.rolesStatusInternal}>
      
        {roleStatus === 'Active'? 
        <div className={myResStyles.resourceNameValue}>
          {resouceData?.resourceName}
        </div>
        :<div className={myResStyles.resourceNameValue}>
          {resouceData.processVariables?.resourceName}
        </div>}

        {roleStatus === 'Active'? 
        <div className={myResStyles.rolevalue}>
          {resouceData?.name}
        </div>
        :<div className={myResStyles.rolevalue}>
          {resouceData.processVariables?.roleName}
        </div>}

        <div
          className={myResStyles.resourcestatus}
          style={{ color: reourceColor }}
        >
          <rotor-icon name={icon}></rotor-icon>{" "}
          {<div style={{ marginLeft: "8px", fontFamily:"Inter" }}> {roleStatus}</div>}{" "}
        </div>
        
        {roleStatus === 'Active'? <></>:
        <a
          className={myResStyles.resourcestatuscontact}
          style={{ color: "#5B6376" }}
          onClick={()=> {
            handleMessage(resouceData.processVariables?.companyAdminEmailIds)
            setOpen(true)
            }}
        >
          <rotor-icon name={"group"}></rotor-icon>{" "}
          {<div style={{ marginLeft: "8px", fontFamily:"Inter" }} 
            > Contact </div>}{" "}
        </a>}
      </div>
    </>
  );
};

export default ResourceStatus;
